import { createSliceWithThunks } from '@castlery/shared-redux-core';
import type { ExtraArgument } from '@castlery/shared-redux-extra';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { login } from '../api/oauth.api';
import { getCurrentAdmin } from '../api/user.api';
import type { User } from '@castlery/types';

const initialState: {
  tokens?: object;
  userInfo?: User;
  page?: 'discover' | 'checkout' | 'SALES HISTORY';
} = {
  tokens: {},
  userInfo: undefined,
};

export const adminSlice = createSliceWithThunks({
  name: 'admin',
  initialState,
  reducers: (create) => {
    return {
      adminLogin: create.asyncThunk(async ({ username, password }, { dispatch, rejectWithValue, extra }) => {
        const res = await dispatch(login.initiate({ username, password }));
        if ('error' in res) {
          return rejectWithValue(res.error);
        }
        const { persistenceHandles } = extra as ExtraArgument;
        const { access_token, refresh_token } = res.data;

        await persistenceHandles.accessToken.setItem(access_token);
        await persistenceHandles.refreshToken.setItem(refresh_token);
        await persistenceHandles.isLoggedIn.setItem('1');

        return res;
      }),
      // enterApp: create.asyncThunk(({ page }: { page: 'discover' | 'checkout' | 'SALES HISTORY' }) => {
      //   return page;
      // }),
    };
  },
  extraReducers(builder) {
    builder.addCase(enterApp.fulfilled, (state, action) => {
      state.page = action.payload;
    });
    builder.addMatcher(getCurrentAdmin.matchFulfilled, (state, action) => {
      state.userInfo = action.payload;
    });
  },
  selectors: {
    selectedAdminUserInfo: (sliceState) => sliceState.userInfo,
    selectedAdminUserName: (sliceState) => {
      let res = ' ';
      if (sliceState.userInfo) {
        res = `${sliceState.userInfo.firstname}  ${sliceState.userInfo.lastname}`;
      }
      return res;
    },
    selectedPage: (sliceState) => sliceState.page,
  },
});

// TODO: abby 需要来规划一下这里 因为这里的page应该和GTM 的 Page type 有映射关系的
export const enterApp = createAsyncThunk(
  'admin/enterApp',
  ({
    page,
  }: {
    page:
      | 'discover'
      | 'checkout'
      | 'SALES HISTORY'
      | 'PLP'
      | 'PLA'
      | 'Blog'
      | 'PRODUCT'
      | 'Home'
      | 'Storyblok'
      | 'entry'
      | 'Account'
      | 'Signin'
      | 'Signup'
      | 'Signout'
      | 'Delivery Review'
      | 'HelpCenter'
      | 'Wishlist'
      | 'ContactUs'
      | 'TermsAndConditions'
      | 'ShopTheLook'
      | 'Referral';
  }) => {
    return page;
  }
);

// export const selectedRefreshToken = (state: RootState) =>
//   state.auth.refresh_token;
export const { adminLogin } = adminSlice.actions;
export const { selectedAdminUserInfo, selectedAdminUserName, selectedPage } = adminSlice.selectors;
export default adminSlice.reducer;
